import axios from 'axios'
import createApiCallConfig from '../../lib/Apis/func/createApiCallConfig'

const apiActions = Object.freeze({
    GET_PASSWORD:  'matrix_get_password',
})

const createConfig = createApiCallConfig(
    apiActions
)

const createApiCall = params => axios(createConfig(params))


export default createApiCall